var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[_c('div',[_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_vm._v(_vm._s(_vm.text))])]),_vm._v(" "),_c('div',{staticClass:"items-baseline pl-2"},[_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_c('icon',{staticClass:"h-5 w-5",attrs:{"name":"arrow-top-right-on-square"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }